export const HOME_TYPE_OPTIONS = [
  { label: "Single Family", value: "SingleFamily" },
  { label: "TownHome", value: "TownHome" },
  { label: "Condo", value: "Condo" },
  { label: "Apartment", value: "Apartment" },
  { label: "Trailer", value: "Trailer" },
];

export const SWING_DIRECTION_OPTIONS = [
  { label: "Left", value: "Left" },
  { label: "Right", value: "Right" },
];

export const ENTRY_TYPE_OPTIONS = [
  { label: "North", value: "North" },
  { label: "South", value: "South" },
  { label: "East", value: "East" },
  { label: "West", value: "West" },
];

export const WATER_HEATER_TYPE_OPTIONS = [
  { label: "Electric", value: "Electric" },
  { label: "Gas", value: "Gas" },
];

export const GARAGE_SIZE_OPTIONS = [
  { label: "1 Car", value: "OneCar" },
  { label: "2 Car", value: "TwoCar" },
  { label: "3 Car", value: "ThreeCar" },
  { label: "4 Car", value: "FourCar" },
];

export const POWER_TYPE_OPTIONS = [
  { label: "Electric", value: "Electric" },
  { label: "Gas", value: "Gas" },
  { label: "Both", value: "Both" },
];

export const GARAGE_TYPE_OPTIONS = [
  { label: "None", value: "None" },
  { label: "Attached", value: "Attached" },
  { label: "Detached", value: "Detached" },
];

export const VENDOR_TYPE_OPTIONS = [
  { label: "Other", value: "Other" },
  { label: "Sand", value: "Sand" },
];

export const ACTIONS_LIST_TYPE = {
  BUTTONS: "BUTTONS",
  ICONS: "ICONS",
};

export const ACCOUNT_TYPE = {
  SERVICE: "Service",
  BUILDER: "Builder",
  SUBCONTRACTOR: "Subcontractor",
  SUPPLIER: "Supplier",
};

export const VENDOR_TYPE = {
  OTHER: "Other",
  SAND: "Sand",
};

export const VENDOR_ACCOUNT_TYPES = [
  ACCOUNT_TYPE.SUBCONTRACTOR,
  ACCOUNT_TYPE.SUPPLIER,
];

export const CUSTOMER_ACCOUNT_TYPES = [
  ACCOUNT_TYPE.BUILDER,
  ACCOUNT_TYPE.SERVICE,
];

export const CONFIG_CALENDAR_TYPES = {
  ORDER: "Order",
  WORK_ORDER: "WorkOrder",
};

export const CALENDAR_TYPES = {
  KANBAN: "Kanban",
  SCHEDULER: "Scheduler",
  HOLDS_LIST: "HoldsList",
  PRIORITY_SCHEDULER: "PriorityScheduler",
};

export const TIME_PREFERENCE_OPTIONS = [
  { label: "None", value: "none" },
  { label: "Morning", value: "morning" },
  { label: "Afternoon", value: "afternoon" },
];

export const PRIORITY_OPTIONS = [
  { label: "Standard", value: "Standard" },
  { label: "Urgent", value: "Urgent" },
  { label: "VIP", value: "VIP" },
];
